import * as React from 'react';
import { SortOrderButton } from './sort-order-button';
import { DefaultSortOrder, DomainNode } from './types';
import { SortOrderModal } from 'ui/sort-order/sort-order-modal';

interface SortOrderProps {
  componentId?: string;
  loadOptions: (query?: string) => void;
  options?: DomainNode[];
  translation?: any;
  onDone?: (sortOrderFields: DefaultSortOrder[]) => void;
  fetching?: boolean;
  sortOrderFields?: DefaultSortOrder[];
}

export const SortOrder = (props:SortOrderProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { componentId, translation, options, loadOptions, onDone, fetching, sortOrderFields } = props;
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div id={componentId}>
      <SortOrderButton
        title={translation && translation.sort_order_title || ''}
        onOpen={handleToggle}
        disabled={fetching} />
      {isOpen &&
        <SortOrderModal
          options={options}
          translation={translation}
          onDone={onDone}
          handleToggle={handleToggle}
          loadOptions={loadOptions}
          sortOrderFields={sortOrderFields}
          />}
    </div>
  );
};
